export class AvoidSetting {

  constructor(list) {
    this.dirtRoad = list.includes('unpaved')
    this.seasonalClosure = null
    this.controlledAccessHighway = null
    this.carShuttleTrain = null
    this.tollRoad = list.includes('tollroad')
    this.ferry = null
    this.tunnel = list.includes('tunnel')
    this.difficultTurns = list.includes('harshTurn')
  }

  toQueryParams() {
    const res = []
    AvoidSetting.KEYS.forEach(key => {
      if (this[key]) {
        res.push(key)
      }
    })
    return res.length ? {
      'avoid[features]': res.join(',')
    } : {}
  }
}

AvoidSetting.KEYS = ["dirtRoad", "seasonalClosure", "controlledAccessHighway", "carShuttleTrain", "tollRoad", "ferry", "tunnel", "difficultTurns"]
